import Config from './Config';
import * as AT from '../../components/container/attributes';
import {HitOnlineEnums} from '@/../../app/src/helpers/constants';

export default class ReportsConfig extends Config {
  constructor({
    id,
    label = 'report.config',
    name = undefined,
    datatype = 'JSON',
    value = undefined,
  }) {
    super({id, label, name, datatype, value});
  }

  static get orderKey() {
    return 'name';
  }

  static get fkName() {
    return 'name';
  }

  static get joinAttrsKey() {
    return ['name'];
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['name']);
  }

  static get detailAttrs() {
    return this.getAttributes(['id', 'label', 'name', 'value']);
  }

  get fkName() {
    return this.name;
  }

  static get allAttributes() {
    return [
      new AT.StringAttribute({
        name: 'id',
        tableProperties: {
          header: 'hit-app.common.id',
          maxWidth: '1fr',
        },
      }),
      new AT.StringAttribute({
        name: 'label',
        tableProperties: {
          header: 'hit-app.common.label',
          maxWidth: '1fr',
        },
        filters: {label: 'eq.report.config'},
      }),
      new AT.StringAttribute({
        name: 'name',
        tableProperties: {
          header: 'hit-app.common.name',
          maxWidth: '1fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'visible',
        tableProperties: {
          header: 'hit-app.common.visible',
        },
      }),
      new AT.BooleanAttribute({
        name: 'customisable',
        tableProperties: {
          header: 'hit-app.common.customisable',
        },
      }),
      new AT.EnumerationAttribute({
        name: 'datatype',
        enumType: 'CONFIG_DATATYPE',
        enumClass: HitOnlineEnums,
        tableProperties: {
          header: 'hit-app.common.datatype',
        },
      }),
      new AT.BooleanAttribute({
        name: 'global',
        tableProperties: {
          header: 'hit-app.common.global',
        },
      }),
      new AT.JsonObjectAttribute({
        name: 'value',
      }),
    ];
  }
}
